<div class="login-container">
  <form class="login-form" (ngSubmit)="submit()">
    <span class="caption-header">{{ 'sign_in_header' | translate }}</span>
    <rs-web-headline [level]="1">{{ 'login_l' | translate }}</rs-web-headline>

    <im-form-field>
      <label class="im:floating-label">
        <span floatingLabel>{{ 'registration_email_input_l' | translate }}</span>
        <input
          class="im:input"
          type="email"
          name="email"
          [formControl]="emailControl"
          [placeholder]="'registration_email_input_l' | translate"
        />
      </label>
    </im-form-field>

    <a im-button class="mb-4" (click)="navigateToRequestResetPasswordPage()"
      >{{ 'password_forgot_a' | translate }}
    </a>

    <button
      im-button
      class="mb-4 primary"
      type="submit"
      [disabled]="!emailControl.valid || federatedLoginDataActionState().pending"
    >
      {{ 'general.log_in_now' | translate }}
    </button>

    <button
      im-button
      class="inverted"
      [disabled]="federatedLoginDataActionState().pending"
      (click)="navigateToRegistration()"
    >
      {{ 'register.to_registration' | translate }}
    </button>
  </form>
</div>
